import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { isContactUsDisable } from '../config';

const Contact: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitting(true);

    // Simulate an API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1500);
  };

  return (
    <Container>
      <Row className="text-center mb-5">
        <Col>
          <h2 className="display-5 fw-bold">Bize Ulaşın</h2>
          <p className="lead text-muted">Teklif almak veya bilgi sormak için bizimle iletişime geçin.</p>
        </Col>
      </Row>
      <Row className={isContactUsDisable ? 'justify-content-md-center' : ''}>
        <Col md={isContactUsDisable ? 8 : 6} className={isContactUsDisable ? 'mb-5' : ''}>
          <h4 className="fw-bold mb-4">İletişim Bilgileri</h4>
          <p className="mb-3">
            <strong>Adres:</strong><br />
            Oruçreis Mahallesi 562. Sokak No: 22/b Esenler/İstanbul
            <br />
            <a 
              href="https://www.google.com/maps/dir/?api=1&destination=Oruçreis+mahallesi+562.sokak+no+22/b+Esenler/İstanbul" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-primary btn-sm mt-2"
            >
              Yol Tarifi Al
            </a>
          </p>
          <p className="mb-3">
            <strong>Telefon:</strong><br />
            <a href="tel:+905327907812" className="text-decoration-none">+90 532 790 78 12</a>
          </p>
          <p className="mb-4">
            <strong>Email:</strong><br />
            <a href="mailto:goktastesisat@gmail.com" className="text-decoration-none">goktastesisat@gmail.com</a>
          </p>
          {/* Google Map */}
          <iframe
            src="https://www.google.com/maps?q=Oruçreis+mahallesi+562.sokak+no+22/b+Esenler/İstanbul&output=embed"
            width="100%"
            height="250"
            style={{ border: 0, borderRadius: '15px' }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Göktaş Tesisat Adresi"
          ></iframe>
        </Col>
        {!isContactUsDisable && (
          <Col md={6}>
            <h4 className="fw-bold mb-4">Mesaj Gönderin</h4>
            {isSubmitted ? (
              <Alert variant="success">
                <Alert.Heading>Mesajınız Alındı!</Alert.Heading>
                <p>
                  En kısa sürede size geri dönüş yapacağız.
                </p>
              </Alert>
            ) : (
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label>Adınız Soyadınız</Form.Label>
                  <Form.Control type="text" placeholder="Adınızı ve soyadınızı girin" required />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email Adresiniz</Form.Label>
                  <Form.Control type="email" placeholder="Email adresinizi girin" required />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formSubject">
                  <Form.Label>Konu</Form.Label>
                  <Form.Control type="text" placeholder="Mesajınızın konusunu girin" required />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formMessage">
                  <Form.Label>Mesajınız</Form.Label>
                  <Form.Control as="textarea" rows={4} placeholder="Mesajınızı buraya yazın" required />
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100" disabled={isSubmitting}>
                  {isSubmitting ? 'Gönderiliyor...' : 'Gönder'}
                </Button>
              </Form>
            )}
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default Contact;